import {
	useAdminFetchAccount,
	useAdminFetchAccountCompanies,
	useAdminFetchAccountIndividuals,
} from "@portal/api/account/admin";
import { CenteredSpinner } from "@portal/components/ui/CenteredSpinner";
import { FC } from "react";
import { AccountTabProps } from "../../../AccountLayout.tsx";
import { AdminAccountCapacitySection } from "./AdminAccountCapacitySection.tsx";
import { AdminAccountCharacterSection } from "./AdminAccountCharacterSection.tsx";
import { AdminAccountCompaniesSection } from "./AdminAccountCompaniesSection.tsx";
import { AdminAccountIndividualsSection } from "./AdminAccountIndividualsSection.tsx";
import { AdminAccountModelSizeSection } from "./AdminAccountModelSizeSection.tsx";

type AdminAccountDetailsTabProps = AccountTabProps;

export const AdminAccountDetailsTab: FC<AdminAccountDetailsTabProps> = ({ accountId }) => {
	const { account } = useAdminFetchAccount(accountId);
	const { companiesIsFetched } = useAdminFetchAccountCompanies(accountId);
	const { individualsIsFetched } = useAdminFetchAccountIndividuals(accountId);

	const contactsReady = !!account && companiesIsFetched && individualsIsFetched;

	return (
		<div className="flex flex-col space-y-[45px] pb-[125px]">
			{!contactsReady ? (
				<CenteredSpinner />
			) : (
				<>
					<AdminAccountIndividualsSection accountId={accountId} />
					<AdminAccountCompaniesSection
						accountId={accountId}
						primaryCompanyId={account.primaryCompanyId}
					/>
				</>
			)}
			<AdminAccountCharacterSection accountId={accountId} />
			<AdminAccountCapacitySection accountId={accountId} />
			<AdminAccountModelSizeSection accountId={accountId} />
		</div>
	);
};
